module.exports = __webpack_public_path__ + "img/certificate-CU-5.5-6.5.0e9da18a.jpg";